import { normalizeWeatherCityKey } from "./agendaWeatherCityLookup";
import { normalizeWeatherHourKey } from "./agendaWeatherHourKey";

export function findHourlyRainForSlot(
  hourRainByCity: Map<string, Map<string, number>>,
  cityName: string,
  hourKey: string
): number | null {
  const normalizedCity = normalizeWeatherCityKey(cityName);
  const cityHours =
    hourRainByCity.get(cityName) ??
    hourRainByCity.get(normalizedCity) ??
    (cityName.trim() ? hourRainByCity.get(cityName.trim()) : undefined);

  if (!cityHours) {
    return null;
  }

  const normalizedHour = normalizeWeatherHourKey(hourKey);
  if (cityHours.has(normalizedHour)) {
    return cityHours.get(normalizedHour) ?? null;
  }

  const hourOnly = normalizedHour.split(":")[0];
  return cityHours.get(`${hourOnly}:00`) ?? null;
}
